// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Ku","hidden":"e_Lu","showMore":"e_Mu","features":"e_Nu","featuresOpened":"e_Ou","colorPositive":"e_Pu","colorNegative":"e_Qu","buttonOpen":"e_Ru","hiddenDesktop":"e_Su"};